"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TridiLibrary = __importStar(require("tridi"));
var Tridi = function (options) {
    var _a;
    var element = options.element;
    var identifier = element.charAt(0) === '.'
        ? 'className'
        : 'id';
    var tridiInstance = TridiLibrary.create(options);
    var _b = react_1.useState(options), tridiOptions = _b[0], setTridiOptions = _b[1];
    react_1.useEffect(function () {
        tridiInstance.load();
    }, []);
    react_1.useEffect(function () {
        setTridiOptions(options);
    }, [options]);
    react_1.useEffect(function () {
        tridiInstance.update(tridiOptions);
    }, [tridiOptions]);
    var tridiProps = (_a = {},
        _a[identifier] = element.substring(1),
        _a);
    return (react_1.default.createElement("div", __assign({}, tridiProps)));
};
exports.default = Tridi;
